module.exports = __webpack_public_path__ + "static/media/GA.baa04091.svg";